import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { AdminInboxCatalogKey } from './inbox.i18n.js';
import { ADMIN_INBOX_CATALOG } from './inbox.i18n.js';

export type AdminInboxMessageId = `adminInbox:${AdminInboxCatalogKey}`;

const PREFIX_LENGTH = 'adminInbox:'.length;

/** `t()` for the stop-gap `adminInbox:` scope (see `inbox.i18n.ts`). */
export function useInboxT(): { t: (id: AdminInboxMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: AdminInboxMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as AdminInboxCatalogKey;
      const raw = ADMIN_INBOX_CATALOG[locale][key] ?? ADMIN_INBOX_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
